// extracted by mini-css-extract-plugin
module.exports = {"freefrom":"FreeFrom_freefrom__AhdwX","button":"FreeFrom_button__tMuz_","title":"FreeFrom_title__ju6Os","list":"FreeFrom_list__PfdWS","listItem":"FreeFrom_listItem__0NNCx"};